// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"7d988941","322":"c4249253","338":"00cd408b","490":"315f756c","766":"7b46302d"}[chunkId] + ".chunk.css";
};